import { memo, useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useTopPanel from 'hooks/useTopPanel';
import ContractsTab from './ContractsTab';
import ContractNumberTab from './ContractNumberTab';

const Contracts = () => {
  const { setComponent } = useTopPanel();
  const { t, i18n } = useTranslation();
  const [tabIndex, setTabIndex] = useState(1);
  const handleChangeTab = (event, newValue) => {
    setTabIndex(() => newValue);
  };

  useEffect(() => {
    setComponent(
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}>
        <Tabs value={tabIndex} onChange={handleChangeTab} type='callsHistory'>
          <Tab label={t('settings.contracts.title')} value={1} />
          <Tab label={t('common.fields.contractNumber')} value={2} />
        </Tabs>
      </Box>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, tabIndex]);

  return (
    <div className='w-full h-full'>
      {tabIndex == 1 && <ContractsTab />}
      {tabIndex == 2 && <ContractNumberTab />}
    </div>
  );
};

export default memo(Contracts);
